import templateUrl from 'emun.salesrep/salesrep-recent-orders.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import orderConfig from 'emun.order/order.config';

class SalesRepRecentOrdersController {
	constructor($rootScope) {
		const $ctrl = this;
		basicController($ctrl);
		var context = $ctrl.context || 'rep';
		$ctrl.orderConfig = orderConfig;
		console.info("this rep", this);
		var filter = "SalesRepID";
		if (context == 'manager') {
			filter = "ManagerId" + '=' + this.repId;
		} else if (context == 'vendor') {
			filter = "VendorId" + '=' + this.repId;
		} else if (context == 'subrep') {
			filter = 'SubRepId' + '=' + this.repId;
		} else {
			filter = filter + '=' + this.repId;
			if ($ctrl.repGroup) {
				if ($ctrl.repGroup !== 'ALL') {
					filter = filter + '&RepGroup=' + $ctrl.repGroup;
				}
			}
		}
		
		$ctrl.openOrders = new AutoQuery({
			url: 'QueryCartsJoin.json?StatusNotEqualTo=Cart&dateRange=Last7&' + filter,
			orderBy: '-OrderedOn',
			autoLoad: true,
			pageSize: 10,
			scrollTop: false
		})
		//$ctrl.openItems = new AutoQuery({
		//    url: 'QueryCartItemsJoin.json?CartStatusNotEqualTo=Cart&' + filter + '=' + this.repId,
		//    orderBy: '-OrderedOn',
		//    autoLoad: true,
		//    pageSize: 10
		//})
	}
}

let SalesRepRecentOrders = {
	bindings: {
		repId: '@',
		rep: '<',
		repGroup: '@',
		context: '@'
	},
	controller: SalesRepRecentOrdersController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl
	}
}

export default SalesRepRecentOrders